module.exports = __webpack_public_path__ + "media/sounds_ringing.a40cba85.mp3";